<template>
  <v-row>
    <v-col cols="3">
      <v-sheet class="pt-4" color="transparent"><!-- style="position:sticky; top:100px" -->
        <v-card width="180px" outlined>
          <v-card-text>
            <v-responsive class="align-center text-center" :aspect-ratio="1/1">
              <img :src="require(`@/assets/appAsset-brand--${activeBiller.brand}.svg`)" :alt="activeBiller.name" width="90%">
            </v-responsive>
          </v-card-text>
        </v-card>
        <v-list class="pl-0" color="transparent">
          <v-list-item class="pl-0">
            <v-list-item-content class="d-block text--secondary font-weight-medium">Compatibilidad</v-list-item-content>
          </v-list-item>
          <v-list-item class="pl-0">
            <v-list-item-content>
              <v-list-item-title class="text--secondary">Países</v-list-item-title>
              <v-list-item-subtitle class="d-block pt-1 caption text--primary">
                <img class="mr-2" v-for="d in activeBiller.countries" :key="d" :src="require(`@/assets/appAsset-flag--${d}.svg`)" :alt="activeBiller.name" height="16px">
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item class="pl-0">
            <v-list-item-content>
              <v-list-item-title class="text--secondary">Tipos de facturas</v-list-item-title>
              <v-list-item-subtitle class="pt-1">
                <span class="d-block mb-1 caption text--primary" v-for="d in activeBiller.invoiceTypes" :key="d">{{d}}</span>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item class="pl-0" v-if="activeBiller.otherTypes && activeBiller.otherTypes.length">
            <v-list-item-content>
              <v-list-item-title class="text--secondary">Otros tipos de documentos</v-list-item-title>
              <v-list-item-subtitle class="pt-1">
                <span class="d-block mb-1 caption text--primary" v-for="d in activeBiller.otherTypes" :key="d">{{d}}</span>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-sheet>
    </v-col>

    <v-col cols="9">
      <v-row>
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="ml-n1 subtitle-1 text--secondary font-weight-medium">
            <router-link :to="{name: 'Integrations'}" class="subtitle-1 routerLink font-weight-medium">Integraciones</router-link>
            <v-icon class="mx-1" color="secondary">mdi-chevron-right</v-icon>{{activeBiller.name}}
          </v-toolbar-title>
        </v-toolbar>
      </v-row>
      <v-row no-gutters>
        <v-col md="3">
          <span class="d-block caption">Documentación</span>
          <v-btn :href="`${$DOCS_BASE}${activeBiller.docs}`" target="_blank" color="primary" text :ripple="false">Ir a la documentación<v-icon right small>mdi-open-in-new</v-icon></v-btn>
        </v-col>
        <v-divider vertical />
        <v-col md="3" class="ml-2">
          <span class="d-block caption">Sitio web</span>
          <v-btn :href="activeBiller.website" target="_blank" color="primary" text :ripple="false">Visitar el sitio<v-icon right small>mdi-open-in-new</v-icon></v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-card>
            <v-toolbar color="transparent" flat height="55">
              <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Información de la integración</v-toolbar-title>
            </v-toolbar>
            <v-divider />
            <v-card-text class="pa-0">
              <span v-if="!installed" class="d-block pt-6 px-5 background text--primary">Utiliza las credenciales de acceso, <span class="text--secondary font-weight-medium">email y contraseña</span>, que utilizas para iniciar sesión en Defontana.</span>

              <v-list v-if="!installed" class="py-3" color="background" dense>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="ml-1 text--secondary subtitle-2 font-weight-medium">{{activeBiller.apiKeyLabel}}</v-list-item-title>
                    <v-list-item-subtitle class="font-weight-regular">
                      <v-col cols="6" class="pa-0">
                        <v-text-field v-model="$v.billerConnection.api_key.$model" :error="$v.billerConnection.api_key.$error" background-color="white" outlined required single-line dense maxlength="254" :placeholder="activeBiller.placeholder" :disabled="installed" hide-details />
                      </v-col>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="ml-1 text--secondary subtitle-2 font-weight-medium">Contraseña</v-list-item-title>
                    <v-list-item-subtitle class="font-weight-regular">
                      <v-col cols="6" class="pa-0">
                        <v-text-field v-model="$v.billerConnection.extra_data.password.$model" autocomplete="new-password" background-color="white" dense :error="$v.billerConnection.extra_data.password.$error" hide-details outlined required single-line type="password" />
                      </v-col>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>

              <v-list class="py-3 v-sm-text-fields" color="background">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="ml-1 text--secondary subtitle-2 font-weight-medium overflow-visible">
                      Empresa
                      <v-chip v-if="!installed" class="ml-1 mt-n1" color="secondary" x-small>Opcional</v-chip>
                    </v-list-item-title>
                    <v-list-item-subtitle class="ml-1 my-1 body-2 text--primary font-weight-regular">
                      <template v-if="installed">Identificador de la empresa registrado en Defontana.</template>
                      <template v-else>Identificador de la empresa registrado en Defontana. Es necesario solo si tienes acceso a más de una empresa en Defontana.</template>
                    </v-list-item-subtitle>
                    <v-list-item-subtitle class="font-weight-regular">
                      <v-col cols="6" class="pa-0">
                        <v-text-field v-model="$v.billerConnection.extra_data.company.$model" background-color="white" dense :error="$v.billerConnection.extra_data.company.$error" hide-details maxlength="24" outlined :placeholder="installed ? 'Sin especificar' : 'Escribe el ID de la empresa...'" :disabled="installed" single-line />
                      </v-col>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>

              <v-list class="py-3 v-sm-text-fields" color="background">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="ml-1 text--secondary subtitle-2 font-weight-medium overflow-visible">Ambiente</v-list-item-title>
                    <v-list-item-subtitle class="ml-1 my-1 body-2 text--primary font-weight-regular">
                      <template v-if="installed">Ambiente de Defontana con el que se ha realizado la integración.</template>
                      <template v-else>Define el ambiente de Defontana con el que quieres realizar la integración.</template>
                    </v-list-item-subtitle>
                    <v-list-item-subtitle class="font-weight-regular">
                      <v-col cols="8" class="pa-0">
                        <v-radio-group class="ml-1" v-model="billerConnection.test_mode" :disabled="installed">
                          <v-radio :value="false">
                            <template v-slot:label>
                              <span class="body-2 text--secondary font-weight-medium">Producción</span>
                              <span class="ml-2 body-2 text--primary  font-italic font-weight-regular">(se conectará con https://erp.defontana.com)</span>
                            </template>
                          </v-radio>
                          <v-radio :value="true">
                            <template v-slot:label>
                              <span class="body-2 text--secondary font-weight-medium">Pruebas</span>
                              <span class="ml-2 body-2 text--primary  font-italic font-weight-regular">(se conectará con https://replerp.defontana.com)</span>
                            </template>
                          </v-radio>
                        </v-radio-group>
                      </v-col>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>

              <span class="d-block pt-3 pb-2 px-5 background text--secondary subtitle-2 font-weight-medium">Tipos de documentos</span>
              <span class="d-block px-5 background text--primary">
                <template v-if="installed">Documentos que forman parte de la integración con Defontana.</template>
                <template v-else>Completa la información de los tipos de documentos que vas a utilizar. El ID del documento lo debes obtener de tu cuenta de Defontana desde <span class="text--secondary font-weight-medium">Configuración &gt; Compras y ventas &gt; Tipos de documentos</span>. Deja en blanco los documentos que no uses.</template>
              </span>

              <v-list class="py-3 v-sm-text-fields" color="background">
                <template v-for="(d, i) in billerConnection.extra_data.analysis_fields">
                  <v-list-item class="py-1 my-0" :key="`${i}-item`">
                    <v-col cols="7" class="pa-0">
                      <v-text-field v-model="$v.billerConnection.extra_data.analysis_fields.$each[i].id.$model" background-color="white" dense :error="$v.billerConnection.extra_data.analysis_fields.$each[i].id.$error" hide-details :placeholder="installed ? 'No integrado' : 'Escribe el ID del documento...'" outlined :disabled="installed" single-line>
                        <template v-slot:prepend-inner>
                          <span class="mx-3">{{d.document | invoiceTypeName}}</span><v-icon class="ml-1" color="secondary" size="17">mdi-arrow-left</v-icon><v-icon color="secondary" size="17">mdi-arrow-right</v-icon>
                        </template>
                      </v-text-field>
                    </v-col>
                  </v-list-item>
                </template>
              </v-list>
            </v-card-text>
            <v-divider />
            <v-card-actions class="pa-4">
              <v-btn v-if="installed" @click="destroyBillerConnection" dark color="red">Desconectar</v-btn>
              <v-spacer />
              <v-btn v-if="!installed" @click="createBillerConnection" :loading="loaderConnect" color="primary">Conectar</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import { cloneDeep } from 'lodash'
import { email, maxLength, required } from 'vuelidate/lib/validators'

import GenericViewMixin from '@/mixins/GenericViewMixin'

import billers from '../../../collections/billers'

export default {
  mixins: [
    GenericViewMixin
  ],
  data: () => ({
    billers: billers,
    billerConnection: {
      biller: 'defontana',
      api_key: '',
      extra_data: {
        analysis_fields: [
          { document: 'CL33', id: null },
          { document: 'CL34', id: null },
          { document: 'CL39', id: null },
          { document: 'CL41', id: null },
          { document: 'CL61', id: null },
          { document: 'CL56', id: null }
        ],
        password: null,
        company: null
      },
      test_mode: false
    },
    installed: false,
    loaderConnect: false
  }),
  computed: {
    ...mapState({
      instance: state => state.billers.billerconnectionsDetail
    }),
    activeBiller () {
      return this.billers.find(b => b.id === 'defontana')
    }
  },
  created () {
    this.retrieveBillerConnection()
  },
  methods: {
    createBillerConnection () {
      this.$v.billerConnection.$touch()

      if (this.$v.billerConnection.$invalid) {
        return false
      }

      this.loaderConnect = true

      const payload = Object.assign({}, this.billerConnection)
      payload.extra_data.analysis_fields = payload.extra_data.analysis_fields.filter(d => d.id)

      this.$store.dispatch('billers/CREATE', {
        resource: 'billerconnections',
        payload: this.billerConnection
      })
      .then(() => {
        this.$dialog.message.info(`Se ha integrado ${this.activeBiller.name}.`)
        this.installed = true
      })
      .catch((error) => {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      })
      .finally(() => {
        this.loaderConnect = false
      })
    },
    destroyBillerConnection () {
      this.$dialog.warning({
        title: `Desconectar ${this.activeBiller.name}`,
        text: `
          <span class="d-block mb-4">¿Estás seguro de desconectar este proveedor de facturación?</span>
          <span class="d-block font-weight-medium">Esta acción no se puede deshacer.</span>
        `,
        actions: [
          {
            color: 'red',
            text: 'Continuar',
            handle: () => {
              this.$store.dispatch('billers/DESTROY', {
                resource: 'billerconnections',
                id: 'defontana'
              })
              .then(() => {
                this.$dialog.message.info(`Se ha eliminado la integración con Defontana.`)

                this.retrieveBillerConnection()

                // reset billerConnection
                this.billerConnection = {
                  biller: 'defontana',
                  api_key: '',
                  extra_data: {
                    password: null,
                    analysis_fields: [
                      { document: 'CL33', id: null },
                      { document: 'CL34', id: null },
                      { document: 'CL39', id: null },
                      { document: 'CL41', id: null },
                      { document: 'CL61', id: null },
                      { document: 'CL56', id: null }
                    ]
                  },
                  test_mode: false
                }
                this.$v.$reset()
              })
              .catch((error) => {
                this.$dialog.message.warning(this.parseErrors(error.response.data))
              })
            }
          }
        ]
      })
    },
    retrieveBillerConnection () {
      this.$store.dispatch('billers/RETRIEVE', {
        resource: 'billerconnections',
        id: 'defontana'
      })
      .then(() => {
        this.installed = true
        this.billerConnection = cloneDeep(this.instance)
      })
      .catch(() => {
        this.installed = false
      })
    }
  },
  validations: {
    billerConnection: {
      api_key: {
        email,
        maxLength: maxLength(128),
        required
      },
      extra_data: {
        password: {
          required
        },
        company: {
          maxLength: maxLength(24)
        },
        analysis_fields: {
          $each: {
            id: {
              maxLength: maxLength(32)
            }
          }
        }
      }
    }
  }
}
</script>